import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ProfileService } from '../../shared-core/services/profile.service';
import NetworkTokenModel from 'src/app/shared-core/models/network-token.model';
import { ActionResponse } from 'src/app/shared-core/models/action-response.model';

@Component({
    selector: 'app-update-payment-method-dialog',
    templateUrl: './update-payment-method-dialog.component.html',
    styleUrls: ['./update-payment-method-dialog.component.scss']
})
export class UpdatePaymentMethodDialogComponent implements OnInit, AfterViewInit {
    @Input()
    public instrumentIdentifierId = '';

    @Output()
    public hidden = new EventEmitter();

    @ViewChild('updatePaymentMethodModal')
    public updatePaymentMethodModal: ModalDirective;

    public paymentMethod: NetworkTokenModel;
    public isReady = false;
    public isSaving = false;

    constructor(
        private _profileService: ProfileService,
        private _elementRef: ElementRef, 
        private _renderer: Renderer2,
        private _toaster: ToastService
    ) { }

    public async ngOnInit(): Promise<void> {
        this._profileService.getPaymentMethod(this.instrumentIdentifierId).subscribe(paymentMethod => {
            if (!paymentMethod) {
                this._toaster.error('Failed to load payment method.');
                this.hideDialog();
                return;
            }

            this.paymentMethod = paymentMethod;
            this.isReady = true;
        });
    }

    public ngAfterViewInit(): void {
        // Modal appears behind backdrop unless its at top of DOM.
        this._renderer.insertBefore(document.body, this._elementRef.nativeElement, document.body.firstChild, true);
        this._elementRef.nativeElement.classList.add('vistekweb');

        this.updatePaymentMethodModal.config = {
            backdrop: 'static'
        }

        this.updatePaymentMethodModal.show();
    }

    // For now, the only thing supported is changing default payment method.
    public changeDefaultPaymentMethod(): void {
        this.isSaving = true;

        this._profileService.changeDefaultPaymentMethod(this.instrumentIdentifierId, this.paymentMethod.isDefault).subscribe((result: ActionResponse) => {
            if (result.isSuccess) {
                window.location.href = window.location.origin + window.location.pathname + '?Message=Successfully%20changed%20default%20payment%20method'
            } else {
                this._toaster.error(result.error);
                this.isSaving = false;
            }

        });
    }
    
    public hideDialog(): void {
        this.updatePaymentMethodModal.hide();
        setTimeout(() => this.hidden.emit(), 50);
    }
}